import React from "react";
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import PropertyLines from "../src/components/propertyLines/PropertyLines";
import data from '../src/constants/data/HakkindaPageData.json';
import WhyPinkBlinds from "../src/components/whyPinkBlinds/WhyPinkBlinds";
import WaveLayout from "../src/layouts/WaweLayout";
import styled from "styled-components";
import {deviceMax} from "../styles/device";
import SubpageHeroArea from "../src/components/subpageHeroArea/SubpageHeroArea";
import AboutUsHeroAreaContent from "../src/components/subpageHeroArea/AboutUsHeroAreaContent";
import NewRegistryButton from "../src/components/heroAreaButtons/newRegistryButton";
import SignUpButton from "../src/components/heroAreaButtons/signUpButton";
import CustomerService from "../src/components/customerService/customerService";
import Security from "../src/components/security/Security";
import MobileApp from "../src/components/mobileApp/MobileApp";
import {NavigationURLs} from "../src/functions/NavigationFunctions";
import Image from "next/image";

const Hakkinda = () => {
    return (
        <React.Fragment>
            <HtmlHead
                pageTitle={'Hakkında | Pembe Panjur'}
                description={'Pembe Panjur hakkında sayfası ile ilgili detaylara sayfamızdan ulaşabilirsiniz.'}
            />

            <WaveLayout
                bodyBackgroundColor={false}
                backgroundColor={'linear-gradient(180deg, #D2147D 0%, #752280 100%)'}
                loginButtonText={false}
                hamburgerMenuType={'white'}
                backgroundType={'linear'}
                registerButton={true}
                extraChildren={
                    <React.Fragment>
                        <AboutContainer>
                            <PropertyLines layoutPage={'hakkinda'} propertyData={data.PropertyLinesHakkindaPageData}/>
                            <WhyPinkBlinds/>
                            <CustomerService/>
                            <Security/>
                            <MobileApp/>
                        </AboutContainer>
                    </React.Fragment>
                }
            >
                <SubpageHeroArea>
                    <Image loading={'lazy'} width={756}
                           height={610}
                           sizes={'100vw'}
                           style={{width: '100%', height: 'auto'}}
                           src={`/next/assets/images/about-us/about-us-mobile-top-v2.png`}
                           alt={'Pembe Panjur'} title={'Pembe Panjur'}
                           className={'about-us-mobile-img-top'}
                    />
                    <AboutUsHeroAreaContent/>
                    <Image loading={'lazy'} width={1126}
                           height={2436}
                           sizes={'100vw'}
                           style={{width: '100%', height: 'auto'}}
                           src={`/next/assets/images/about-us/hakkinda-mobile-bottom-min.png`}
                           alt={'Pembe Panjur'} title={'Pembe Panjur'}
                           className={'about-us-mobile-img-bottom'}
                    />
                    <NewRegistryButton/>
                    <SignUpButton backgroundColor={'#fff'} textColor={false} url={NavigationURLs.landing}/>
                    <div className={'about-us-desktop-img'}>
                        <Image loading={'lazy'} width={958}
                               height={1496}
                               sizes={'100vw'}
                               style={{width: '100%', height: 'auto'}}
                               src={`/next/assets/images/about-us/hakkinda-desktop-ten-billion.png`}
                               alt={'Pembe Panjur'} title={'Pembe Panjur'}
                               className={'about-us-desktop-img'}
                        />
                    </div>
                </SubpageHeroArea>
            </WaveLayout>
        </React.Fragment>
    )
}

const AboutContainer = styled.div`
  position: relative;
  padding-left: calc(50vw - 575px);
  padding-right: calc(50vw - 575px);
  padding-top: 26px;

  @media ${deviceMax.tablet} {
    padding: 0;
    box-sizing: border-box;

    > div {
      padding-left: 0;
      padding-right: 0;
      margin-left: 0;
      margin-right: 0;
      width: 100%;
      box-sizing: border-box;

      &:first-child {
        padding-left: 20px;
        padding-right: 20px;
      }
    }
  }
`;


import { checkAuthAndRedirect } from '../src/utils/authHelper';

export const getServerSideProps = async (context: any) => {
    return await checkAuthAndRedirect(context);
};


export default Hakkinda;
